import React, { useEffect, useRef } from "react";

export default function AnnouncementModal({ open, onClose, announcement }) {
  const closeBtnRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const t = window.setTimeout(() => closeBtnRef.current?.focus(), 0);

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      window.clearTimeout(t);
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open || !announcement) return null;

  const title = announcement.title || "Important Update";
  const message = announcement.message || "";

  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop */}
      <button
        type="button"
        aria-label="Close announcement"
        onClick={onClose}
        className="absolute inset-0 h-full w-full bg-black/60 animate-fadeIn"
      />

      {/* Bottom sheet container */}
      <div className="absolute inset-x-0 bottom-0 flex justify-center p-3 sm:p-4">
        <div className="w-full max-w-2xl overflow-hidden rounded-2xl bg-white shadow-2xl border border-amber-100 animate-slideUp">
          {/* Header */}
          <div className="bg-gradient-to-r from-amber-700 to-amber-500 px-4 py-3 text-white">
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/15 ring-1 ring-white/25">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                    className="text-white"
                  >
                    <path
                      d="M12 9v4m0 4h.01M10.29 3.86l-7.5 13A2 2 0 0 0 4.5 20h15a2 2 0 0 0 1.71-3.14l-7.5-13a2 2 0 0 0-3.42 0Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <h2 className="font-serif text-lg leading-6">{title}</h2>
              </div>

              <button
                ref={closeBtnRef}
                type="button"
                onClick={onClose}
                className="rounded-lg bg-white/15 px-3 py-1.5 text-sm font-medium text-white ring-1 ring-white/25 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/70"
              >
                Close
              </button>
            </div>
          </div>

          {/* Body */}
          <div className="px-4 py-4">
            <p className="text-gray-800 text-[15px] leading-6">{message}</p>
            <p className="mt-3 text-xs text-gray-500">
              Thank you for understanding.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}